module.exports = __webpack_public_path__ + "static/media/au.186ee49e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/au.svg
// module id = 2038
// module chunks = 0